export default __webpack_public_path__ + "static/media/scraps.708ac735.png";